import React from "react";
import PropTypes from "prop-types";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from "@mui/material";
import { FormattedMessage } from "react-intl";
import { formatDate } from "../../../../utils/formatter/dateTimeFormatter";
import { EDIT } from "../../../../common/Authorization/permissions";
import { CREDENTIAL } from "../../../../common/Authorization/entities";
import { HasAccessTo } from "../../../../components/Authorization";
const CredentialRequestsTable = (props) => {
  const {
    className,
    credentialRequests,
    handlePageChange,
    handleRowsPerPageChange,
    page,
    rowsPerPage,
    totalCount,
    loading
  } = props;
  const disabledIfNoAccessToCredentialsEdit = !HasAccessTo(CREDENTIAL, EDIT);
  return /* @__PURE__ */ React.createElement(Card, { className }, /* @__PURE__ */ React.createElement(CardContent, { sx: { padding: 0 } }, /* @__PURE__ */ React.createElement(PerfectScrollbar, null, /* @__PURE__ */ React.createElement(Box, { sx: { minWidth: 1050 } }, /* @__PURE__ */ React.createElement(Table, null, /* @__PURE__ */ React.createElement(TableHead, null, /* @__PURE__ */ React.createElement(TableRow, null, /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "credentialRequests.name" })), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "owners.title" })), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "credentialRequests.packageType" })), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "credentialRequests.createdAt" })), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "credentialRequests.connect" })))), /* @__PURE__ */ React.createElement(TableBody, null, loading && new Array(rowsPerPage).fill((index) => index).map((value, index) => /* @__PURE__ */ React.createElement(TableRow, { key: index }, /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(Skeleton, null)), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(Skeleton, null)), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(Skeleton, null)), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(Skeleton, null)), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(Skeleton, null)))), !loading && credentialRequests.map((credentialRequest) => /* @__PURE__ */ React.createElement(TableRow, { hover: true, key: credentialRequest.requestId }, /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Typography, { variant: "body1" }, credentialRequest.name))), /* @__PURE__ */ React.createElement(TableCell, null, credentialRequest.owner?.ownerName), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: `packages.type.${credentialRequest.packageType}` })), /* @__PURE__ */ React.createElement(TableCell, null, formatDate(credentialRequest.createdAt)), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(
    Button,
    {
      variant: "outlined",
      href: `${process.env.REACT_APP_AUTH_URL}/connect/${credentialRequest.packageType}/${credentialRequest.requestId}`,
      target: "_blank",
      rel: "noopener noreferrer",
      disabled: disabledIfNoAccessToCredentialsEdit
    },
    /* @__PURE__ */ React.createElement(FormattedMessage, { id: "credentialRequests.connect" })
  ))))))))), /* @__PURE__ */ React.createElement(CardActions, { sx: { justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(
    TablePagination,
    {
      component: "div",
      count: totalCount,
      onPageChange: handlePageChange,
      onRowsPerPageChange: handleRowsPerPageChange,
      page,
      rowsPerPage,
      rowsPerPageOptions: [5, 10, 25, 50, 100]
    }
  )));
};
CredentialRequestsTable.propTypes = {
  className: PropTypes.string,
  credentialRequests: PropTypes.array.isRequired
};
export default CredentialRequestsTable;
